<div class="overlay" *ngIf="isVisible">
    <div class="content">
        <div class="spinner-border" role="status">
            <span class="visually-hidden">Loading...</span>
          </div>
    </div>
  </div>
  